import { derived, writable } from "svelte/store";
import { bankAccount } from "@retailer/stores/BankAccountStore";

//types
import type { PaymentInstrument } from "@shared/types/PaymentInstrument";

export type PaymentInstrumentsRequest = {
  paymentInstruments: PaymentInstrument[];
  loaded: boolean;
  failed: boolean;
};

const initialPaymentInstrumentState: PaymentInstrumentsRequest = {
  loaded: false,
  failed: false,
  paymentInstruments: [],
};

export const paymentInstrumentsStore = writable<PaymentInstrumentsRequest>(
  initialPaymentInstrumentState,
);

export const pendingPaymentInstruments = derived(bankAccount, $bankAccount =>
  $bankAccount === null
    ? []
    : $bankAccount.plaid_items
        .map(item => {
          const accts = item.plaid_accounts.filter(account => {
            return (
              account.verification_status == "pending_automatic_verification" ||
              account.verification_status == "pending_manual_verification"
            );
          });
          return accts.map(acct => {
            return { institution_name: item.institution_name, plaid_account: acct };
          });
        })
        .flat(),
);
